import React from 'react';
import { SkeletonTable } from '../../components/Skeleton/Table';

const Loading: React.FC = () => <SkeletonTable columns={8} rows={15} />;

export default Loading;
